/*
 * np-vcid.js — Voluum click-id capture + conversion-attribution bridge.
 * Built 2026-08-31 (Voluum Meta campaign build, contract c_1423481bcd).
 *
 * WHAT: the Voluum offer redirect lands visitors on this site with
 *   ?cid=<voluum click id> (also accepts vcid=), plus avatar= and offer=/oc=.
 * This script persists the click id (90d localStorage + cookie) and mirrors
 * it into Shopify CART ATTRIBUTES so every order carries note_attributes
 * [vcid, np_avatar, np_offer_cell]. A server-side sync job
 * (scripts/nightly/np_voluum_conversion_sync.py) then reads paid orders and
 * fires the Voluum S2S postback — no checkout scripts / pixels needed, and
 * it keeps working when browser pixels are blocked.
 *
 * Safe by design: no-ops for organic visitors with no stored click id,
 * never throws (everything wrapped), fires network calls only after load,
 * and only writes cart attributes when they differ from what's stored.
 */
(function () {
  'use strict';

  var LS_KEY = 'np_vcid';
  var COOKIE = 'np_vcid';
  var DAYS = 90;

  function getParam(name) {
    try {
      var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function readCookie(name) {
    try {
      var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function store(key, val) {
    try { window.localStorage.setItem(key, val); } catch (e) {}
    try {
      var d = new Date(); d.setTime(d.getTime() + DAYS * 864e5);
      document.cookie = key + '=' + encodeURIComponent(val) +
        '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  function stored(key) {
    var v = null;
    try { v = window.localStorage.getItem(key); } catch (e) {}
    return v || readCookie(key);
  }

  // 1. Capture from URL (a fresh click always wins over an old stored one).
  var cid = getParam('cid') || getParam('vcid');
  // 2026-10-23 attribution fix: across a returning-visitor re-entry the PAID ad click (saved by
  // np-funnel-sticky.js as the 2h np_paid cookie) owns attribution, never the re-entry click id.
  // np-funnel-sticky.js already swaps the URL; this is the belt-and-braces read of the same cookie.
  var paidCid = readCookie('np_paid');
  if (paidCid && !/[{}]/.test(paidCid)) cid = paidCid;
  var avatar = getParam('avatar');
  var cell = getParam('oc') || getParam('offer');
  if (cid && !/[{}]/.test(cid)) store(LS_KEY, cid);          // ignore unresolved {clickid} macros
  if (avatar) store('np_avatar', avatar);
  if (cell && /^[A-Ga-g]$/.test(cell)) store('np_cell', cell.toUpperCase()); // A-G (F/G added 2026-09-01; regex fixed 2026-09-28)
  // 2026-10-24 direct-product-page test: which hop the visitor came through. ?path=direct is the
  // 4th Voluum path (straight to /products/relax-gummies); otherwise the hop np-funnel-sticky.js
  // recorded in the .npgummy.com np_fx cookie (h=landra|landra2|quiz|direct). Orders then show
  // note_attributes np_path next to np_avatar / np_offer_cell.
  var pathParam = getParam('path');
  if (pathParam === 'direct' || pathParam === 'directv2') store('np_path', pathParam);   // directv2 = Resilia-layout PDP (2026-10-24)
  function fxHop() {
    try {
      var fx = readCookie('np_fx');
      var m = fx && /(?:^|&)h=(landra2?|quiz|directv2|direct)(?:&|$)/.exec(fx);
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }

  // 2. After load, mirror into cart attributes (creates the cart if needed
  //    only when we actually have a click id to attribute).
  function sync() {
    var vcid = stored(LS_KEY);
    if (!vcid) return; // organic visitor — nothing to do
    var want = {
      vcid: vcid,
      np_avatar: stored('np_avatar') || '',
      np_offer_cell: stored('np_cell') || '',
      np_path: stored('np_path') || fxHop() || ''
    };
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var a = (cart && cart.attributes) || {};
          if (a.vcid === want.vcid &&
              a.np_avatar === want.np_avatar &&
              a.np_offer_cell === want.np_offer_cell &&
              (a.np_path || '') === want.np_path) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: want })
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  if (document.readyState === 'complete') { sync(); }
  else { window.addEventListener('load', sync); }

  // Re-sync after any add-to-cart (a brand-new cart drops attributes set on a
  // previous empty-cart token). Cheap: listens for fetch/XHR to /cart/add.
  try {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        p.then(function () { setTimeout(sync, 500); }).catch(function () {});
      }
      return p;
    };
  } catch (e) {}
})();
